// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-aGzseJM5","title":"title-1hdBcIXX"};